<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <el-tag
        size="small"
        :type="getType(scope.row.status).tag"
        v-if="!scope.row.task_items || (scope.row.task_items && scope.row.task_items.length === 0)"
      >
        {{ getType(scope.row.status).label }}
      </el-tag>
      <el-tag
        size="small"
        v-else
        :type="getType(scope.row.status).tag"
      >
        <i class="el-icon-circle-check"></i> {{ getItemsStatus(scope.row.task_items) }}/{{ scope.row.task_items.length }} {{ getType(scope.row.status).label }}
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
  methods: {
    getItemsStatus(items) {
      let done = 0;
      items.map(item => item.status === 'done' ? done++ : '');
      return done;
    },
    getType(status) {
      switch (status) {
        case 'todo':
          return {
            tag: 'danger',
            label: 'Elintézendő',
          };
          break;
        case 'in-progress':
          return {
            tag: 'warning',
            label: 'Folyamatban',
          };
          break;
        case 'done':
          return {
            tag: 'success',
            label: 'Kész',
          };
          break;
      }
    }
  },
};
</script>
